'use strict';
let body = $('body');

$('#modal-close, #overlay').click( function() {
    $('#modal-alert, #modal-video')
        .animate({opacity: 0, top: '100px'}, 200,
            function() {
                $(this).css('display', 'none');
                $('#overlay').fadeOut(400);
            }
        );
    let vid = body.find('.youtube-video'),
        src = vid.prop('src');
    vid.prop('src', '').prop('src', src.replace('?autoplay=1', ''));

});

// ***************** SCROLL **************** //
function smoothScrollingTo(target){
    $('html,body').animate({
        scrollTop: $(target).offset().top -50
    }, 500);
}
$('.menu a[href*=\\#]').on('click', function(event){
    event.preventDefault();
    smoothScrollingTo(this.hash);
});

// *********** SERVICES ********** //
body.on('click', '.toggle-services', function (e) {
    e.preventDefault();

    let modal = body.find('.modal-services');
    if (modal.hasClass('active')) {
        modal.removeClass('active');
    } else {
        modal.addClass('active');
    }
});

body.on('click', '.toggle-menu', function (e) {
    e.preventDefault();

    let modal = body.find('.mobile-menu');
    if (modal.hasClass('active')) {
        modal.removeClass('active');
    } else {
        modal.addClass('active');
    }
});

body.on('click', '.contacts-form button[type="submit"]', function(e) {
    e.preventDefault();

    let form = $(this).closest('form');
    let url = form.attr('action');

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function(result)
        {
            form[0].reset();
            alert(result['body']);
        }
    });

});
